import moment from 'moment';
import { BACKEND_DATE_FORMAT } from 'common/js/constants/constants';
import VueDatepicker from '@ui-common/vue-datepicker';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import messages from './treasury-kids-form.json';

export default {
	data: () => ({
		model: {
			day: null,
			displayNameType: null
		}
	}),
	props: {
		displayNames: {
			type: Array,
			required: true
		},
		date: {
			type: String,
			required: true
		}
	},
	i18n: { messages },
	watch: {
		date(val) {
			if (val) {
				this.model.day = val;
			}
		},
		['model.displayNameType'](val) {
			this.$store.dispatch('treasuryKids/setDisplayName', val);
		}
	},
	components: {
		VueDatepicker,
		VueSelect,
		VueSelectOption
	},
	computed: {
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		minDate() {
			return moment('2000-01-01').format(BACKEND_DATE_FORMAT);
		},
		maxDate() {
			return moment().format(BACKEND_DATE_FORMAT);
		}
	},
	methods: {
		getFiles() {
			if (moment(this.model.day).isValid()) {
				this.$emit('date-change', this.model.day);
			}
		}
	}
};
